<ul>
  <li *ngFor="let link of links">
    <a [href]="link.url">
      <i class="fa-solid fa-angle-right"></i>
      <p class="text-truncate">{{link.name}}</p>
    </a>
  </li>
</ul>